/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { FormTextInput } from '../../pages/common/inputs/TextInput';
import { FormProvider, useForm } from 'react-hook-form';
import { useRequiredValidation } from '../../../utils/form/validation.utils';
import { createTenant } from '../../../app/resource/user-tenants/user-tenants.actions';
import { ICreateTenantFromUserData } from '../../../app/resource/user-tenants/user-tenants.types';

export const WorkspaceCreationDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const formProps = useForm();
  const requiredValidation = useRequiredValidation();

  const handleSubmit = useCallback(
    (data: ICreateTenantFromUserData) => {
      dispatch(createTenant(data));
    },
    [dispatch],
  );

  const onClose = useCallback(() => {
    dispatch(closeDialog('workspaceCreationDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="workspaceCreationDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">Create new workspace</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <FormProvider {...formProps}>
              <form id="workspaceCreationDialog-form" onSubmit={formProps.handleSubmit(handleSubmit)}>
                <div className="field-container">
                  <FormTextInput
                    id="tenantName"
                    name="tenantName"
                    type="text"
                    placeholder="Company name"
                    validation={requiredValidation}
                  />
                </div>
                {/* <FormTextInput id="timezone" name="timezone" type="hidden" placeholder="Time zone" />
                {error && <label style={{ color: 'red' }}>{getApiErrorMessage(error)}</label>} */}
              </form>
            </FormProvider>
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="createTenant" formName="workspaceCreationDialog-form" text="Send" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
